import { render } from "./CodeReviewFinding.vue?vue&type=template&id=232e9f9a&scoped=true"
import script from "./CodeReviewFinding.vue?vue&type=script&lang=js"
export * from "./CodeReviewFinding.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=232e9f9a&scoped=true&lang=css&external"
import "./CodeReviewFinding.vue?vue&type=style&index=1&id=232e9f9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232e9f9a"]])

export default __exports__